export default __webpack_public_path__ + "static/media/logo-monday.357b6d1e.png";